const API_URL = process.env.REACT_APP_API_URL || '/api';

export async function login(email, password, newPassword, session) {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, newPassword, session })
  });
  const data = await res.json();
  return data;
}

export function getStoredToken() {
  const t = localStorage.getItem('access_token');
  if (!t || t === 'undefined' || t === 'null') return null;
  return t;
}

async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken || refreshToken === 'undefined' || refreshToken === 'null') return null;
    
    const res = await fetch(`${API_URL}/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken })
    });
    
    if (!res.ok) return null;
    const data = await res.json();
    if (data.access_token) {
      localStorage.setItem('access_token', data.access_token);
      return data.access_token;
    }
    return null;
  } catch {
    return null;
  }
}

export async function apiCall(path, options = {}) {
  const token = getStoredToken();
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...options.headers
    }
  });

  if (res.status === 401) {
    // Try to refresh the token
    const newToken = await refreshAccessToken();
    if (newToken) {
      // Retry the request with new token
      const retryRes = await fetch(`${API_URL}${path}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${newToken}`,
          ...options.headers
        }
      });
      if (retryRes.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return;
      }
      return retryRes.json();
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login';
      return;
    }
  }

  return res.json();
}